import { useContext, useEffect } from 'react';
import axios from '../api/axios';
import { SocketContext } from '../context/SocketProvider';
import { ISocketContext } from '../types/socketclient';
import useAuth from './useAuth';

const useRefreshToken = () => {
  const { setAuth } = useAuth();
  const { shouldConnectSocket, setShouldConnectSocket } = useContext(
    SocketContext,
  ) as ISocketContext;
  useEffect(() => {
    if (!shouldConnectSocket) {
      setShouldConnectSocket(true);
    }
  }, [setShouldConnectSocket, shouldConnectSocket]);
  const refresh = async () => {
    const response = await axios.get('/refresh', {
      withCredentials: true,
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAuth((prev: any) => {
      return {
        ...prev,
        accessToken: response.data.accessToken,
        roles: response.data.roles,
        aiTrainingComplete: response.data.aiTrainingComplete,
      };
    });
    return response.data.accessToken;
  };
  return refresh;
};

export default useRefreshToken;
